/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Shipping_AdjustmentInputs */

const en_create_shipping_adjustment = /** @type {(inputs: Create_Shipping_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Shipping Adjustment`)
};

const es_create_shipping_adjustment = /** @type {(inputs: Create_Shipping_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear ajuste de envio`)
};

/**
* | output |
* | --- |
* | "Create Shipping Adjustment" |
*
* @param {Create_Shipping_AdjustmentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const create_shipping_adjustment = /** @type {((inputs?: Create_Shipping_AdjustmentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Shipping_AdjustmentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_shipping_adjustment(inputs)
	return es_create_shipping_adjustment(inputs)
});